<template>
	<!-- eslint-disable -->
	<Toast />
	<div class="Grid">
		<div class="col-12">
			<Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
		</div>
		<div class="col-12 mb-4">
			<div class="card">
				<div class="content-header">Report PO Status</div>
				<div class="content-body">
					<div class="mt-4">
						<TableReportPoStatus :company="company" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import TableReportPoStatus from './components/TableReportPoStatus.vue';
import AuthService from '@/service/AuthService';
import LovService from '@/service/LovService';
import SimpleCrypto from 'simple-crypto-js';

const company = ref(null);

const breadcrumbHome = { icon: 'pi pi-home', to: '/' };
const breadcrumbItems = [
	{
		label: 'Report PO Status',
		to: '/reportpostatus',
	},
];

const userCompany = () => {
	const secretKey = 'some-unique-key';
	const simpleCrypto = new SimpleCrypto(secretKey);
	return simpleCrypto.decrypt(sessionStorage.getItem('dropdownCompany'));
};

onMounted(async () => {
	const response = await AuthService.whoAmi();
	if (response.status === 200) {
		const respCbN = await LovService.getCompanyByName(userCompany());
		company.value = respCbN.data.data[0];
	}
});
</script>

<style scoped></style>
